export default __webpack_public_path__ + "static/differential-scroll-01-43f894b59d885399d54a9942ce6c6908.jpg";